import useSWR from 'swr';
import { Area } from '@modules/clients/modules/CompanyDetails/components/AreasList/AreasList';

/**
 * Obtains a list of areas by customer
 * @param allowRequest - Indicates whether the request to fetch areas should be made. If `false`, the request will not be executed
 */
const useAreas = () => {
  const { data, isLoading, error, mutate } = useSWR<Area[]>(() => '/v3/partner/areas', {
    revalidateOnFocus: false,
  });

  return { data: data ?? [], isLoading, error, mutate };
};
export default useAreas;
